const MACT_EMAIL_DOMAIN = "@mact.ru";

/**
 * Логин на странице входа: локальная часть без «@» дополняется доменом @mact.ru;
 * полный e-mail (уже с «@») передаётся как есть (в нижнем регистре).
 */
export function normalizeLoginEmailForAuth(rawLogin) {
  const trimmed = String(rawLogin ?? "").trim();
  if (!trimmed) {
    return "";
  }
  const lower = trimmed.toLocaleLowerCase();
  if (lower.includes("@")) {
    return lower;
  }
  return `${lower}${MACT_EMAIL_DOMAIN}`;
}
